<template>
  <div class="border">
    <list
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="false"
      :fields="fields"
      :params="params"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </div>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  props: ["id"],
  created() {
    this.itemLink += `/${this.id}/variants`;
    this.setLink += `/${this.id}/variants`;
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "field",
      fields: [
        {
          col: " col-12 col-md-12",
          key: "variants",
          label: "Товар",
          type: "selects",
          modal: "variant",
          selectKey: "name",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "",
      itemLink: "tariffs",
      setLink: "tariffs",
      columns: [
        {
          key: "name",
          title: "Товар",
          titleKey: "product",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          full: true,
        },
        {
          titleKey: "barcode",
          key: "barcode",
          title: "Баркод",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          full: true,
        },
        {
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
